import { render, staticRenderFns } from "./SubmissionComponent.vue?vue&type=template&id=082fcecc&scoped=true&style=background%3A%20%23FAFAFA%3B&"
import script from "./SubmissionComponent.vue?vue&type=script&lang=js&"
export * from "./SubmissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionComponent.vue?vue&type=style&index=0&id=082fcecc&lang=scss&scoped=true&"
import style1 from "./SubmissionComponent.vue?vue&type=style&index=1&id=082fcecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082fcecc",
  null
  
)

export default component.exports